import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of, timeout } from 'rxjs';

import { TenantFeatureService } from '@app/shared/services/tenant-feature.service';

/** How long the shell waits for the features; a slower answer still arrives and the flagged UI follows. */
export const TENANT_FEATURES_WAIT_MS = 3_000;

/**
 * Loads the tenant's features before the shell renders, so the navigation and every flagged tab
 * (SCIM, SSO, Brand Kit, …) show with the page instead of popping in a moment later. Runs after
 * the authentication guard (the request needs the token) and never blocks longer than
 * {@link TENANT_FEATURES_WAIT_MS}: without an answer the page opens with what is known.
 */
export const tenantFeaturesResolver: ResolveFn<Record<string, boolean>> = () =>
  inject(TenantFeatureService)
    .load()
    .pipe(
      timeout({ first: TENANT_FEATURES_WAIT_MS }),
      catchError(() => of({} as Record<string, boolean>)),
    );
